/**
 * 学習ドリルAPI
 */
import { Component, Vue } from 'vue-property-decorator'
import { ApiResponseDrillStart, ApiResponseLoadProblems, ApiStudyAnswer } from '@/models/apiResponses/drill'

@Component
export default class DrillApi extends Vue {
  /**
   * 学習ドリル開始（結果ドリルID生成・取得）API
   * @param sUnitId 小項目ID
   * @param isFirstTime 初回フラグ
   * @param isOnlyMistake 間違い直しフラグ
   * @returns 結果ドリルID
   */
  protected async drillStartApi(
    sUnitId: number,
    isFirstTime: boolean,
    isOnlyMistake: boolean
  ): Promise<ApiResponseDrillStart> {
    const { data }: { data: ApiResponseDrillStart } = await Vue.prototype.$http.httpWithToken.post(
      `/v2/student/study/start`,
      { sUnitId: sUnitId, isFirstTime: isFirstTime, isOnlyMistake: isOnlyMistake }
    )

    return data
  }

  /**
   * 学習ドリルに紐付く出題大問・問題情報一覧取得API
   * @param 結果ドリルID
   * @returns 出題大問・問題情報一覧
   */
  protected async loadProblemsApi(resultDrillId: number): Promise<ApiResponseLoadProblems> {
    const { data }: { data: ApiResponseLoadProblems } = await Vue.prototype.$http.httpWithToken.get(
      '/v2/student/study/problems',
      {
        params: { resultDrillId: resultDrillId },
      }
    )

    return data
  }

  /**
   * 画像のBase64データを非同期で読み込むAPI
   * @param resultDrillId 結果ドリルID
   * @param imageUrls 画像URLの配列
   * @returns Base64画像データのマップ
   */
  protected async loadImagesApi(
    resultDrillId: number,
    imageUrls: string[]
  ): Promise<{ image_data: { [key: string]: string }; loaded_count: number; total_requested: number }> {
    const { data } = await Vue.prototype.$http.httpWithToken.post('/v2/student/study/load_images', {
      study: {
        result_drill_id: resultDrillId,
        image_urls: imageUrls,
      },
    })

    return data
  }

  /**
   * 学習解答リクエスト送信API
   */
  protected async saveQuestionStudyAnswerApi(studyAnswer: ApiStudyAnswer, captureData?: string): Promise<void> {
    const payload = {
      study: {
        ...studyAnswer,
        capture_data: captureData,
      },
    }
    await Vue.prototype.$http.httpWithToken.post('/v2/student/study/answers', payload)
  }

  /**
   * テスト完了提出
   */
  protected async drillCompleteApi(
    studyAnswer: ApiStudyAnswer,
    onSuccess: (response: ApiResponseLoadProblems) => Promise<void>,
    onError: () => Promise<void>
  ): Promise<void> {
    const payload = {
      study: {
        ...studyAnswer,
      },
    }
    await Vue.prototype.$http.httpWithToken
      .post('/v2/student/study/complete', payload)
      .then(async (response: { data: ApiResponseLoadProblems }) => {
        onSuccess(response.data)
      })
      .catch(async () => {
        onError()
      })
  }
}
